import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveNote = async (uuid: string) => {
  const response = await CustomAxios.post(`notes/${uuid}/archive`);
  return response.data;
};

interface UseArchiveNoteProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveNote({ uuid, onSuccessCallback }: UseArchiveNoteProps) {
  return useMutation({
    mutationFn: () => archiveNote(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allNotes, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the note. Please try again and contact support if the problem persists.');
      }
    },
  });
}
